const APIS = {
  DEFAULT_BRANCH: "/logisticservice/api/branch/default-branch/",
  STAFF: "/logisticservice/api/staff/",
  USER: "/usermanagementservice/api/user/",
  USER_PROFILE: "/logisticservice/api/user-profile/",
  STATUS: "/logisticservice/api/status/",
  FILE_HANDLER: "/driveservice/api/file/",
};

export default APIS;
